//src/components/services/index.js
import React from 'react';
import { Check } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ServiceCard = ({ 
  category,
  serviceId,
  title, 
  tagline, 
  taglineColor,
  image, 
  fallbackImage,
  description, 
  price, 
  features, 
  getImage
}) => {
  const navigate = useNavigate();
  
  const handleBookNow = () => {
    // Store selected service in localStorage to pass to booking page
    const serviceDetails = {
      id: serviceId,
      category,
      title,
      description,
      price,
      tagline
    };
    
    localStorage.setItem('selectedService', JSON.stringify(serviceDetails));
    
    // Navigate to booking page with service info
    navigate('/book');
  };
  
  // Feature rendering logic (same as before)
  const renderFeatures = () => {
    // If features is an object with sections
    if (typeof features === 'object' && !Array.isArray(features)) {
      return Object.entries(features).map(([section, items]) => (
        <div key={section} className="mb-3">
          <h4 className="font-semibold mb-2 uppercase text-sm text-gray-500">{section}</h4>
          <ul className="space-y-2">
            {items.map((feature, index) => (
              <li key={index} className="flex items-center text-gray-700 text-sm">
                <Check className="h-4 w-4 text-blue-500 mr-2 flex-shrink-0" />
                <span>{feature}</span>
              </li>
            ))}
          </ul>
        </div>
      ));
    }
    
    // If features is a simple array
    return (
      <div className="mb-3">
        <h4 className="font-semibold mb-2 uppercase text-sm text-gray-500">WHAT'S INCLUDED</h4>
        <ul className="space-y-2">
          {features.map((feature, index) => (
            <li key={index} className="flex items-center text-gray-700 text-sm">
              <Check className="h-4 w-4 text-blue-500 mr-2 flex-shrink-0" />
              <span>{feature}</span>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div className="bg-white rounded-3xl overflow-hidden shadow-lg border border-gray-100 transition-all duration-300 hover:shadow-xl relative">
      <div className="p-6 pb-4 border-b border-gray-100">
        <div className="flex justify-between items-center mb-2">
          <h3 className="text-xl font-bold text-gray-800">{title}</h3>
          <span className={`text-${taglineColor} text-sm italic font-medium`}>{tagline}</span>
        </div>
        <div className="h-48 -mx-6 overflow-hidden">
          <img 
            src={getImage(image, fallbackImage)} 
            alt={`${title} Package`} 
            className="w-full h-full object-cover"
          />
        </div>
        <p className="text-sm text-gray-600 mt-3">{description}</p>
        <p className="text-lg font-bold mt-2">Starting at ${price}</p>
      </div>
      
      {/* Features */}
      <div className="p-6">
        {renderFeatures()}
        
        {/* Book Now button */}
        <div className="mt-6">
          <button 
            onClick={handleBookNow}
            className="w-full bg-blue-500 text-white py-3 rounded-lg font-medium transition-all duration-300 hover:bg-blue-600"
          >
            Book Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;